import { useNavigate } from 'react-router-dom';

import { DialogKey } from 'components/navigation/WithDialogs';

import { useGenerateDialogPath } from './useGenerateDialogPath';

export const useOpenDialog = () => {
  const navigate = useNavigate();
  const generatedPath = useGenerateDialogPath();
  return (
    dialogKey: DialogKey,
    dialogParam: string,
    opts?: {
      basePath?: string;
      replace?: boolean;
      additionalParams?: Record<string, string | string[]>;
    }
  ) => {
    const { replace, ...rest } = opts || {};
    navigate(generatedPath(dialogKey, dialogParam, rest), {
      preventScrollReset: true,
      replace,
    });
  };
};
